import numeral from "numeral";

// load a locale
numeral.register("locale", "br", {
  delimiters: {
    thousands: ".",
    decimal: ","
  },
  abbreviations: {
    thousand: "k",
    million: "m",
    billion: "b",
    trillion: "t"
  },
  ordinal: function(number) {
    return number === 1 ? "um" : "uns";
  },
  currency: {
    symbol: "R$"
  }
});

// switch between locales
numeral.locale("br");

export function formatNumber(num) {
  return numeral(num).format("0,0[.]00");
}

export function formatPercentage(num, pattern = "0[.]000%") {
  if (isNaN(num) || num === "-" || num === Infinity) return "-";
  return numeral(num).format(pattern);
}

export default numeral;



// WEBPACK FOOTER //
// ./src/utils/numeral.js